import React, { useEffect, useState, useCallback } from "react";
import DataTable from "../Components/Common/DataTable";
import PremiumFilterBar from "../Components/Common/PremiumFilterBar";
import DeleteButton from "../Components/Common/DeleteButton";
import ViewButton from "./Common/ViewButton";
import LoaderCon from "../../Common/loader/containers/loader_cont";
import Snackbar1 from "../../Common/snackbar/components/snackbar";
import { downloadExcel } from "../../utils/downloadExcel";

const statusColors = {
  Requested: "#6366f1",       // Indigo
  Pending: "#f59e0b",         // Amber
  "In Progress": "#3b82f6",   // Blue
  Resolved: "#22c55e",        // Green
  Closed: "#6b7280",          // Gray
};


export default function Service({
  login,
  client,
  viewAllContactUs,
  deleteContact,
  updateContactStatus,
  close_snack_bar,
  snackbar
}) {
  const [searchInput, setSearchInput] = useState("");
  const [page, setPage] = useState(1);
  const [rowsPerPage] = useState(20);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("");
  const [editingStatusId, setEditingStatusId] = useState(null);

  const fetchData = useCallback(() => {
    viewAllContactUs(
      login.token,
      login.user_id,
      searchInput,
      page,
      rowsPerPage,
      startDate,
      endDate,
      selectedStatus
    );
  }, [login, searchInput, page, rowsPerPage, startDate, endDate, selectedStatus, viewAllContactUs]);

  // Debounced search
  useEffect(() => {
    const timer = setTimeout(fetchData, 300);
    return () => clearTimeout(timer);
  }, [searchInput, fetchData]);

  // Reload on page/rows/date/status change
  useEffect(() => {
    fetchData();
  }, [page, rowsPerPage, startDate, endDate, selectedStatus, fetchData]);


  const contact = client?.all_contactUs || [];
  // const contactCount = client?.all_contactlength || 0;
  const contactCount = contact.length;
  const pageLength = client?.contact_length || 0;
  const handleDownloadExcel = () => {
    downloadExcel(
      "contactus/export-contact-us", // ✅ Correct backend endpoint
      "ContactUsReport",             // File name
      "POST",
      {
        search: searchInput,
        startDate: startDate,
        endDate: endDate,
        status: selectedStatus,
        user_id: login.user_id,
      },
      login.token
    );
  };

  const columns = [
    {
      header: "Name",
      key: "name",
      render: (row) => `${row.firstName || ""} ${row.lastName || ""}`.trim(),
    },
    { header: "Mobile", key: "mobile" },
    { header: "Email", key: "email" },
    { header: "Address", key: "queryType" },
    {
      header: "Created Date",
      key: "createdAt",
      render: (row) => {
        const date = new Date(row.createdAt);
        const formattedDate = date.toLocaleDateString();
        const formattedTime = date.toLocaleTimeString();

        return (
          <span style={{ display: "flex", flexDirection: "column", lineHeight: "16px" }}>
            <span>{formattedDate}</span>
            <span style={{ fontSize: "12px", color: "#555" }}>{formattedTime}</span>
          </span>
        );
      },
    },

    {
      header: "Last Updated",
      key: "updatedAt",
      render: (row) => {
        const date = new Date(row.updatedAt);
        const formattedDate = date.toLocaleDateString();
        const formattedTime = date.toLocaleTimeString();

        return (
          <span style={{ display: "flex", flexDirection: "column", lineHeight: "16px" }}>
            <span>{formattedDate}</span>
            <span style={{ fontSize: "12px", color: "#555" }}>{formattedTime}</span>
          </span>
        );
      },
    },
    {
      header: "Status",
      key: "status",
      render: (row) => {
        const isEditing = editingStatusId === row._id;

        return (
          <div style={{ display: "flex", justifyContent: "center" }}>
            {isEditing ? (
              <select
                autoFocus
                defaultValue={row.status}
                onChange={(e) => {
                  const newStatus = e.target.value;

                  updateContactStatus(
                    login.token,
                    login.user_id,
                    row._id,
                    newStatus,
                    page,
                    rowsPerPage
                  );

                  setEditingStatusId(null);
                }}
                onBlur={() => setEditingStatusId(null)} // Close if mouse clicked outside
                className="premium-select"
                style={{ padding: "4px 8px" }}
              >
                <option>Requested</option>
                <option>Pending</option>
                <option>In Progress</option>
                <option>Resolved</option>
                <option>Closed</option>
              </select>
            ) : (
              <span
                onClick={() => setEditingStatusId(row._id)}
                style={{
                  padding: "6px 14px",
                  borderRadius: "20px",
                  color: "white",
                  backgroundColor: statusColors[row.status] || "#6b7280",
                  cursor: "pointer",
                  fontSize: "12px",
                  fontWeight: "600",
                  textTransform: "uppercase",
                  letterSpacing: "0.5px"
                }}
              >
                {row.status}
              </span>
            )}
          </div>
        );
      },
    },

    {
      header: "Action",
      key: "action",
      render: (row) => (
        <div style={{ display: "flex", gap: "6px", justifyContent: "center" }}>
          <ViewButton
            title="Contact Details"
            fields={[
              { label: "First Name", key: "firstName" },
              { label: "Last Name", key: "lastName" },
              { label: "Mobile", key: "mobile" },
              { label: "Email", key: "email" },
              { label: "Address", key: "queryType" },

              // CREATED DATE DISPLAY FIX
              {
                label: "Created Date",
                key: "createdAt",
                render: (row) => {
                  const d = new Date(row.createdAt);
                  return (
                    <>
                      {d.toLocaleDateString()} <br />
                      <span style={{ fontSize: "12px", color: "#555" }}>
                        {d.toLocaleTimeString()}
                      </span>
                    </>
                  );
                },
              },

              // UPDATED DATE DISPLAY FIX
              {
                label: "Last Updated",
                key: "updatedAt",
                render: (row) => {
                  const d = new Date(row.updatedAt);
                  return (
                    <>
                      {d.toLocaleDateString()} <br />
                      <span style={{ fontSize: "12px", color: "#555" }}>
                        {d.toLocaleTimeString()}
                      </span>
                    </>
                  );
                },
              },

              { label: "Status", key: "status" },
            ]}
            data={row}
            buttonLabel="View"
          />
          <DeleteButton
            item={row}
            viewName="Contact"
            onDelete={(contact) => deleteContact(login.token, login.user_id, contact._id, page,
              rowsPerPage)}
          />
        </div>
      ),
    }

  ];

  return (
    <div>
      <PremiumFilterBar
        title={`Contact Us (${contactCount})`}
        searchInput={searchInput}
        setSearchInput={setSearchInput}
        selectedStatus={selectedStatus}
        setSelectedStatus={setSelectedStatus}
        onDateChange={({ start, end }) => {
          setStartDate(start);
          setEndDate(end);
        }}
        onExport={handleDownloadExcel}
      />

      <DataTable
        columns={columns}
        data={contact}
        page={page}
        rowsPerPage={rowsPerPage}
        totalPage={pageLength}
        onPageChange={(p) => setPage(p)}
      />
      <LoaderCon />
    </div>
  );
}

